var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_13745)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 135,
    rx: 67.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 22,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -34,
    y: 90.5,
    width: 203,
    height: 203,
    rx: 101.5,
    fill: "#CFCFCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_13745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 135,
    rx: 67.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.a6910d6d3514227095d0c0eb250d7d5c.svg";
export { ForwardRef as ReactComponent };